// Session-scoped intake store used across /estimate → /book → /success.

const KEY = "green-services.intake.v1";

export function loadIntake() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveIntake(data) {
  sessionStorage.setItem(KEY, JSON.stringify(data));
}

export function clearIntake() {
  sessionStorage.removeItem(KEY);
}

// Estimate math — takes a live config from /api/public/estimate-config
// (falls back to Phase-1 defaults so the UI never breaks if fetch fails).
export const FALLBACK_CONFIG = {
  hourly_rate: 100,
  minimum: 100,
  hours: { sidewalk: 1, deck: 2, furniture: 1, other: 1 },
};

const round25 = (n) => Math.round(n / 25) * 25;

export function computeEstimate(scope, config = FALLBACK_CONFIG) {
  const h = config?.hours || FALLBACK_CONFIG.hours;
  let hours = 0;
  if (scope?.sidewalk) hours += Number(h.sidewalk) || 0;
  if (scope?.deck) hours += Number(h.deck) || 0;
  if (scope?.furniture) hours += Number(h.furniture) || 0;
  if (scope?.other) hours += Number(h.other) || 0;
  const rate = Number(config?.hourly_rate) || FALLBACK_CONFIG.hourly_rate;
  const minimum = Number(config?.minimum) || FALLBACK_CONFIG.minimum;
  const base = Math.max(minimum, hours * rate);
  return {
    hours,
    low: round25(base),
    high: round25(base * 1.5),
    hourly_rate: rate,
    minimum,
  };
}

export const SCOPE_LABELS = {
  sidewalk: "Sidewalk / Walkway",
  deck: "Deck / Patio",
  furniture: "Outdoor Furniture",
  other: "Other",
};

export const FREQUENCY_LABELS = {
  one_time: "One-time deep clean",
  weekly: "Weekly",
  biweekly: "Bi-weekly",
  monthly: "Monthly",
};
